/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * - REGULAR means that this role has no self-service specific properties - SELF_SERVICE means that this role is for self-service users - SELF_SERVICE_PRIVATE means this role is for self-service and automatically assigned to users who registered a new private person self-service account - SELF_SERVICE_LEGAL means that this role is for self-service automatically assigned to users who created a legal person via self-service 
 */
export type RoleType = 'REGULAR' | 'SELF_SERVICE' | 'SELF_SERVICE_PRIVATE' | 'SELF_SERVICE_LEGAL';

export const RoleType = {
    Regular: 'REGULAR' as RoleType,
    SelfService: 'SELF_SERVICE' as RoleType,
    SelfServicePrivate: 'SELF_SERVICE_PRIVATE' as RoleType,
    SelfServiceLegal: 'SELF_SERVICE_LEGAL' as RoleType
};

